module.exports = __webpack_public_path__ + "img/clock.ef05f19d.svg";